import { environment } from '../../environment';

export const getApiEndPointUrl = (...paths: (string | number)[]): string => `${environment.apiUrl}${paths.join('/')}`;

export const getAnalyticsApiEndPointUrl = (...paths: string[]): string =>
	`${environment.surveyAnalyticsApiUrl}${paths.join('/')}`;
